import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { convertMoneyToNumber, formatAmountOnly } from '../../util/currency';
import { CurrencySymbol } from '../../components';
import { propTypes } from '../../util/types';
import { resolveLatestProcessName, getProcess } from '../../transactions/transaction';

import css from './OrderBreakdown.module.css';

const LineItemTotalPrice = props => {
  const { transaction, isProvider, intl } = props;
  const processName = resolveLatestProcessName(transaction?.attributes?.processName);
  if (!processName) {
    return null;
  }
  const process = getProcess(processName);
  const isCompleted = process.isCompleted(transaction?.attributes?.lastTransition);
  const isRefunded = process.isRefunded(transaction?.attributes?.lastTransition);

  let providerTotalMessageId = 'OrderBreakdown.providerTotalDefault';
  if (isCompleted) {
    providerTotalMessageId = 'OrderBreakdown.providerTotalReceived';
  } else if (isRefunded) {
    providerTotalMessageId = 'OrderBreakdown.providerTotalRefunded';
  }

  const totalLabel = isProvider ? (
    <FormattedMessage id={providerTotalMessageId} />
  ) : (
    <FormattedMessage id="OrderBreakdown.total" />
  );

  // Sharetribe's own line-item reversal never fires for transition/customer-cancel,
  // so payoutTotal below still holds the pre-cancellation amount and doesn't
  // reflect that the provider only actually keeps the cancellation-fee
  // portion (settleCancellationFee credits just that, not the full payout).
  // Deliberately NOT substituted with cancellationSettlement.merchantCredit
  // here -- this line sits directly under the pre-cancellation line items
  // (Subtotal / NOW fee / VAT), which still sum to payoutTotal, so swapping
  // this one number in without touching those just produces a total that
  // contradicts the math shown right above it. CancellationSettlementMaybe
  // (rendered separately, right below this) is the actual source of truth
  // for what got withheld/refunded/credited post-cancellation.
  const totalPrice = isProvider
    ? transaction.attributes.payoutTotal
    : transaction.attributes.payinTotal;
  const totalAmount = totalPrice ? convertMoneyToNumber(totalPrice) : 0;
  const formattedTotalAmount = formatAmountOnly(intl, totalAmount, 2);

  return (
    <>
      <hr className={css.totalDivider} />
      <div className={css.lineItemTotal}>
        <div className={css.totalLabel}>{totalLabel}</div>
        <div className={css.totalPrice}>
          <CurrencySymbol size={18} />
          <span>&nbsp;{formattedTotalAmount}</span>
        </div>
      </div>
    </>
  );
};

LineItemTotalPrice.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemTotalPrice;
